module.exports = __webpack_public_path__ + "img/blog9.956773b0.jpeg";